"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var AutoSuggest_1 = require("../../components/AutoSuggest");
AutoSuggest_1.AutoSuggest.getInstance();
